<template>
  <div id="externalPasswordReset">

    <div class="vo-external-card">
      <vo-external-header :title="title"></vo-external-header>

      <div class="vo-body">
        
        <div class="vo-title">{{ title }}</div>
        
        <div class="vo-context">To change your password, enter and confirm a new password. You'll be redirected to the login page when completed.</div>

        <v-text-field :validate-on-blur="$refs.pass1Input && $refs.pass1Input.valid" label="New Password" ref="pass1Input" type="password" v-model="pass1" @keyup.enter="resetPassword" :rules="rules.pass1"></v-text-field>

        <v-text-field :validate-on-blur="$refs.pass2Input && $refs.pass2Input.valid" label="Confirm New Password" ref="pass2Input" type="password" v-model="pass2" @keyup.enter="resetPassword" :rules="rules.pass2"></v-text-field>
        
      </div>

      <v-btn block flat class="vo-card-button" :loading="lockout" v-ripple @click="resetPassword">RESET PASSWORD</v-btn>
    </div>

  </div>
</template>

<script>

  export default {

    data () {
      return {
        verification: false,
        title: 'Password Reset',
        pass1: '',
        pass2: '',
        lockout: false,
        rules: {
          pass1: [
            function (e) {
              return (!e || e.length < 6) ? 'Password must be at least 6 characters long.' : true;
            }.bind(this)
          ],
          pass2: [
            function (e) {
              return (this.pass1 !== this.pass2) ? 'Passwords do not match.' : true;
            }.bind(this)
          ]
        }
      }
    },

    methods: {
      
      // resetPassword() - Validates form, returns errors if applicable, resets password if validation passes
      resetPassword () {
        if (this.lockout) return;
        this.lockout = true;

        // Validate
        var valid = this.validateForm();
        
        if (!valid) { 
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout = false;
          return;
        }

        // Reset Password
        this.$store.dispatch('verifyPasswordToken', {
          password: this.pass1,
          token: this.verification.token
        })
        .then(data => {
          
          this.lockout = false;

          Dialog.showDialog({
            title: 'Password Changed',
            body: 'Your password has been reset. You will now be redirected to the login page.',
            confirm: {
              title: 'Got It',
              action () {
                console.log('WINDOW.APP_URL', window.APP_URL);
                window.open(APP_URL, '_self');
                return Promise.resolve();
              }
            },
            modal: true
          });

        })
        .catch(e => {
          this.lockout = false;
          console.log('Error:', e);
          Toast.showError(e);
        });

      },
      
      // fetchVerificationToken(token) - Fetches verification using token, then calls appropriate function 
      fetchVerificationFromToken (token) {
        this.$store.dispatch('loadVerificationToken', {
          token: token
        })
        .then(data => {
          this.handleVerification(data);
        })
        .catch(e => {
          this.handleInvalidToken();
        });
      },


      // handleVerification(verification) - Checks verification for validity, allows the user to continue if valid
      handleVerification (verification) {

        // Incorrect Verification type
        if (verification.type !== 'password reset') {
          this.handleInvalidToken();
        }

        // Already Verified
        else if (verification.status === 'verified') {

          Dialog.showDialog({
            title: 'Password Already Changed',
            body: 'Your password has already been successfully reset. You will now be redirected to the login page, where you can sign in with your new password. If you cannot sign in, you can request a new password change request.',
            confirm: {
              title: 'Got It',
              action () {
                console.log('WINDOW.APP_URL', window.APP_URL);
                window.open(APP_URL, '_self');
                return Promise.resolve();
              }
            },
            modal: true
          });
          
        }

        // Expired
        else if (verification.status === 'expired') {
          
          Dialog.showDialog({
            title: 'Token Expired',
            body: 'Your password reset token has expired. You will not be redirected to the login page. If you still need to reset your password, you can create a new request on the login page.',
            confirm: {
              title: 'Got It',
              action () {
                console.log('WINDOW.APP_URL', window.APP_URL);
                window.open(APP_URL, '_self');
                return Promise.resolve();
              }
            },
            modal: true
          });
        }

        // Expected status
        else if (verification.status === 'sent') {
          this.verification = verification;
        }

        // Other unexpected state
        else {
          this.handleInvalidToken();
        }

      },

      handleInvalidToken () {

        // Token not found
        Dialog.showDialog({
          title: 'Token Invalid',
          body: 'Your password reset token is invalid. You will now be redirected to the login page, where you can request a new password reset email.',
          confirm: {
            title: 'Got It',
            action () {
              console.log('WINDOW.APP_URL', window.APP_URL);
              window.open(APP_URL, '_self');
              return Promise.resolve();
            }
          },
          modal: true
        });

      },

      // validateForm() - Validates all inputs, returns whether or not ALL inputs are valid
      validateForm () {
        this.$refs.pass1Input.validate(true);
        this.$refs.pass2Input.validate(true);

        return (this.$refs.pass1Input.valid && this.$refs.pass2Input.valid);
      },

      initForm () {
        this.$refs.pass1Input.valid = true;
        this.$refs.pass2Input.valid = true;
      }

    },

    mounted () {
      
      // Init inputs as valid (inputs are created after 1 tick)
      this.$nextTick(() => {
        this.initForm();
      });

      // Make sure user has a token
      if (!this.$route.query || this.$route.query && !this.$route.query.token) this.handleInvalidToken();
      else this.fetchVerificationFromToken(this.$route.query.token);

    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #externalPasswordReset {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    @include scrollable;
  }

  @media screen and (max-width: 780px) {
   
    #externalPasswordReset {
      
      background: $lightGreen !important;

      .vo-title {
        display: none;
      }
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/ExternalPasswordReset.vue